import { Observable } from 'rxjs';

import {
	ChannelAnalogLevel,
	ChannelLoudspeaker,
	ChannelOutputPath,
	InputSource
} from '@shure/shared/angular/data-access/system-api/models';

import { DspDevice, DspDeviceChannel, DspDeviceChannelMetering } from '../models';

export abstract class ChannelInfoApiService {
	/**
	 * Get device to display schematics for.
	 */
	public abstract getDevice$(deviceId: string): Observable<DspDevice>;

	/**
	 * Get channel on device.
	 */
	public abstract getChannel$(channelId: string): Observable<DspDeviceChannel>;

	/**
	 * Get metering on channel.
	 */
	public abstract getChannelMetering$(channelId: string, isVirtual: boolean): Observable<DspDeviceChannelMetering>;

	/**
	 * Get metering on channel.
	 */
	public abstract getStereoChannelMetering$(
		channelId: string,
		isVirtual: boolean
	): Observable<DspDeviceChannelMetering>;

	/**
	 * Set channel name.
	 */
	public abstract setChannelName(channelId: string, name: string): Observable<void>;

	/**
	 * Set mute for channel.
	 */
	public abstract setChannelMute(channelId: string, muted: boolean): Observable<void>;

	/**
	 * Set gain for channel.
	 */
	public abstract setChannelGain(channelId: string, gain: number): Observable<void>;

	public abstract setChannelAnalogLevel(channelId: string, level: ChannelAnalogLevel): Observable<void>;

	public abstract setChannelAutoMute(channelId: string, enabled: boolean): Observable<void>;

	/**
	 * Set PC I/O for channels.
	 */
	public abstract setPcPeripheral(channelId: string, selectedPeripheralId: string): Observable<void>;

	/**
	 * Set Input source for channels.
	 */
	public abstract setInputSource(channelId: string, selectedInputSource: InputSource): Observable<void>;

	/**
	 * Set output path for channels.
	 */
	public abstract setOutputPath(channelId: string, selectedOutputPath: ChannelOutputPath): Observable<void>;

	/**
	 * Set type of passive speaker.
	 */
	public abstract setPassiveSpeakerType(channelId: string, type: ChannelLoudspeaker): Observable<void>;
}
